import { reject, either, isNil, isEmpty, uniq } from 'ramda';

const filterEmpty = reject<string | null | undefined>(either(isNil, isEmpty));

/**
 * Concatenates class names to a single class name string.
 * @param classNames The class names to combine.
 */
export function concatClassNames(...classNames: (string | undefined | null)[]): string {
  return uniq(filterEmpty(classNames)).join(' ');
}
